const CURATION_DETAIL_LEVEL = {
  PARTIAL_CURATION: {
    label: 'Partial',
    value: 'PARTIAL_CURATION',
  },
  FULL_CURATION: {
    label: 'Full',
    value: 'FULL_CURATION',
  },
  NO_CURATION: {
    label: 'No Curation',
    value: 'NO_CURATION',
  },
}

export default CURATION_DETAIL_LEVEL
